import React, { useMemo } from 'react';
import * as filterKeyMap from './_config';
import './index.scss';
import { renderGenreBotton } from '@intelligence/components/GenreSelectMiddleware/Supports/utils';
import { useIntl, getLocale } from 'umi';
import useLocae from '@/pages/home/components/NewRegionSelect/useLocale'; // 国家筛选器使用
import { getText } from '@/pages/home/components/NewRegionSelect/util';
import {
  LOCALE_CN,
  VALUE_TYPE_REGION,
} from '@/pages/home/components/NewRegionSelect/config'; // 国家筛选器使用
import appAnnieIcon from '@/pages/intelligence/assets/svg/dataSource/app-annie.svg';
import dataBrainIcon from '@/pages/intelligence/assets/svg/dataSource/databarin-bg.svg';
import sensortowerIcon from '@intelligence/assets/svg/dataSource/sensor-tower.svg';
import AppMagicIcon from '@intelligence/assets/imgs/dataSource/app-magic.png';
import WeixinIcon from '@intelligence/assets/imgs/casualDailyReports/icon-weixin.png';
import DouYinIcon from '@intelligence/assets/imgs/casualDailyReports/icon-dy.png';
import {
  showTimeByDateType,
  newMathFormat,
} from '@/pages/intelligence/utils/commonUtils';
import { useFilterOptionList } from '@/pages/intelligence/hooks/useFilterOptionList';
import { getStoreRankPlatformOptions } from '@intelligence/components/TeaSelector/SourceSelect/utils';
import { renderSinglePlatformOptions } from '@intelligence/components/TeaSelector/SinglePlatformSelect';
import IconDom from '@intelligence/components/SelectCompoenet/ItemDom/IconDom';
import { SENSOR_TOWER_TAG_THEME } from '@/pages/intelligence/components/Filter/FilterBase/_config.ts';
import {
  COMMON_JOINER,
  getOptionText,
  analysisDataSourceMetricKey,
} from '@intelligence/utils/topchartsUtils';
import { getIPOStatusesNamesMapping } from '@/pages/intelligence/components/TeaSelector/IPOStatusSelector';
import { getDataSourceIcon } from '@intelligence/utils/getDataSourceImg';
import SvgIcon from '@home/components/SvgIcon';
import { REVENUE_SCOPE_VALUES } from '@intelligence/utils/revenueScope';
import _ from 'lodash';

import ICON_APPMAGIC from '@intelligence/assets/imgs/dataSource/app-magic.png';

const findTextByValue = (options: any[], findValue: string) =>
  options?.filter((e) => e?.value === findValue)[0]?.text;

const renderOption = (
  value: any,
  options: any[],
  formatMessage: Function,
  isCascaderSegment = false, // 是否为Cascader筛选器选项展示
) => {
  // const { formatMessage } = useIntl();
  let result: any = [];
  let newOptions = [];

  if (isCascaderSegment) {
    const matchedItems = options?.filter((item1: any) =>
      value?.find(
        (item2: any) =>
          item1.source === item2.source && item1.value === item2.value,
      ),
    );
    result = matchedItems;
    newOptions = matchedItems;
  } else {
    result =
      typeof value === 'string' ? [value] : Array.isArray(value) ? value : [];
    newOptions = !Array.isArray(options)
      ? []
      : options?.filter((item) => result?.includes(item?.value));
  }

  if (result?.length > 2 && result?.length === options?.length) {
    return formatMessage?.({ id: 'dbi_all' });
  }
  if (result?.length > 2) {
    return result?.length;
  }
  if (isCascaderSegment) {
    return newOptions?.map((item: any, index: number) => {
      return RenderImgText(
        item?.text,
        item?.img,
        index === newOptions?.length - 1,
      );
    });
  }
  return newOptions?.map((item: any, index: number) =>
    RenderImgText(item.text, item?.img, index === newOptions?.length - 1),
  );

  // 只有2个的全选: 展示2个文本渲染
  // 大于2个的全选：展示All
  // 1/2个非全选：展示数据文本
  // 大于2个非全选： 展示数字
  // return (
  //   <>
  //     {result?.length > 2 && result?.length === options?.length
  //       ? formatMessage?.({ id: 'dbi_all' })
  //       : result?.length > 2
  //       ? result?.length
  //       : newOptions?.map((item, index) =>
  //           RenderImgText(item.text, item?.img, index === newOptions?.length - 1),
  //         )}
  //   </>
  // );
};

const getValueFormatter = (valueObj: any) => {
  const objArr = Object.entries(valueObj)?.flatMap(([source, values]) =>
    values?.map((value: any) => ({ source, value })),
  );
  return objArr || [];
};

const getRegionSubOptions = (options) => {
  const allChildren: any[] = [];
  options?.forEach((item) => {
    item?.country_set?.forEach((subItem) => {
      allChildren.push({
        value: subItem?.country_code,
        text: subItem?.country_name_en,
        textCN: subItem?.country_name_ch,
      });
    });
  });

  return allChildren;
};

const radioOptions = [
  {
    value: 'global',
    text: 'Global',
    textCN: '全球',
  },
  {
    value: 'global_wo_china',
    text: 'Global except China mainland',
    textCN: '全球（不包括中国大陆）',
  },
];
/**
 * 筛选项多选总结：
 * 1 除了国家地区、Genre筛选器超出1个显示数量，其中品类是按主品类个数来论
 * 2 其他筛选器都是超出2个则显示数量；单选项不能多选所以仅能选择一个或者All
 * 3 All的情况： 如果只有2个则特殊处理全部展示， 大于等于3则展示All或数量
 *
 */

const RenderRangeDate = (props: any) => {
  const { key, valueItem } = props;
  const { formatMessage } = useIntl();
  const { type, value } = valueItem || {};
  const startDate = showTimeByDateType(value?.[0], type);
  const endDate = showTimeByDateType(value?.[1], type);
  return (
    <>
      <span className="model-form-text">
        {key === filterKeyMap.RELEASE_TIME
          ? formatMessage({ id: 'dbi_filterSave_release' })
          : formatMessage({ id: 'dbi_filterSave_duration' })}
      </span>
      <span className="model-form-context">
        {startDate && endDate
          ? `${startDate} ~ ${endDate}`
          : formatMessage({ id: 'dbi_filterSave_none' })}
      </span>
    </>
  );
};

// 国家
const RenderRegion = (props: any): React.ReactElement => {
  const { options: regionOptions, valueItem, title } = props;
  const { type = '', regions = [], markets = [] } = valueItem || {};
  const locale = getLocale();
  const { formatMessage } = useLocae(locale, {}); // 不要用useIntl的
  const allChildren: any[] = getRegionSubOptions(regionOptions);

  const render = useMemo(() => {
    const titleText = title ? formatMessage({ id: title }) : '';
    const titleRegion = titleText || formatMessage({ id: 'button_region' });
    const titleMarket = titleText || formatMessage({ id: 'button_market' });
    if (!Array.isArray(regionOptions)) {
      return (
        <>
          <span className="model-form-text">{titleRegion}</span>
          <span className="model-form-context">
            {/* {getText(findRegion, locale) || regions[0]} */}
          </span>
        </>
      );
    }
    if (type === VALUE_TYPE_REGION) {
      if (regions.length === 1) {
        const findRegion = regionOptions?.find(
          (item) => item.area_code === regions[0],
        );
        const formatRegion = {
          text: findRegion?.area_name_en,
          textCN: findRegion?.area_name_ch,
          value: findRegion?.area_code,
        };
        return (
          <>
            <span className="model-form-text">{titleRegion}</span>
            <span className="model-form-context">
              {getText(formatRegion, locale) || regions[0]}
            </span>
          </>
        );
      }

      return (
        <>
          <span className="model-form-text">{titleRegion}</span>
          <span className="model-form-context">{regions.length || ''}</span>
        </>
      );
    }

    if (markets.length === 1) {
      const oneMarket = markets[0];

      const findRadio = radioOptions?.find((item) => item.value === oneMarket);
      if (findRadio) {
        return (
          <>
            <span className="model-form-text">{titleRegion}</span>
            <span className="model-form-context">
              {(locale === LOCALE_CN ? findRadio?.textCN : findRadio?.text) ||
                oneMarket}
            </span>
          </>
        );
      }

      const findMarket = allChildren?.find((item) => item?.value === oneMarket);
      return (
        <>
          <span className="model-form-text">{titleMarket}</span>
          <span className="model-form-context">
            {getText(findMarket, locale) || oneMarket}
          </span>
        </>
      );
    }

    return (
      <>
        <span className="model-form-text">{titleMarket}</span>
        <span className="model-form-context">{markets.length || ''}</span>
      </>
    );
  }, [valueItem, regionOptions, formatMessage, title]);

  return <>{render}</>;
};

const mobileGenreDataSourceIconMap: IRecord<string> = {
  iegg: dataBrainIcon,
  appannie: appAnnieIcon,
  sensortower: sensortowerIcon,
  appmagic: AppMagicIcon,
  wechat_minigame: WeixinIcon,
};
/* 品类筛选器 */
const RenderGenretor = (props: any) => {
  const { valueItem } = props;
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const { source, mainGenres, subGenres } = valueItem || {};
  // 和品类展示一至
  const result = renderGenreBotton(locale, mainGenres, subGenres);
  const dataSourceIcon = mobileGenreDataSourceIconMap[source] || appAnnieIcon;

  return (
    <>
      <span className="model-form-text">
        {formatMessage({ id: 'dbi_top_genre' })}
      </span>
      <img
        style={{ marginRight: 4, width: 16, verticalAlign: 'middle' }}
        src={dataSourceIcon}
      />
      <span className="model-form-context">
        {!mainGenres?.length
          ? formatMessage({ id: 'dbi_all' })
          : mainGenres?.length > 1
          ? mainGenres?.length
          : result}
      </span>
    </>
  );
};

const RenderImgText = (text: string, img = '', isLastOne = false) => (
  <>
    {img && (
      <img
        style={{ width: 16, verticalAlign: 'middle', marginRight: 4 }}
        src={img}
      />
    )}
    <span>{text}</span>
    {isLastOne ? null : (
      <span style={{ marginRight: isLastOne ? 0 : 6 }}>,</span>
    )}
  </>
);

const RenderDataSource = (props: any) => {
  const { formatMessage } = useIntl();
  const { dataSourceFilterOptionsAll } = useFilterOptionList({
    formatMessage,
  });
  return (
    <>
      <span className="model-form-text">
        {formatMessage({ id: 'dbi_source' })}
      </span>
      <span className="model-form-context">
        {renderOption(
          props?.valueItem?.value,
          dataSourceFilterOptionsAll,
          formatMessage,
        )}
      </span>
    </>
  );
};

const RenderDataSourceSingle = (props: any) => {
  const { formatMessage } = useIntl();
  const { dataSourceFilterOptionsAll } = useFilterOptionList({
    formatMessage,
  });

  return (
    <>
      <span className="model-form-text">
        {formatMessage({ id: 'dbi_source' })}
      </span>
      <span className="model-form-context">
        {renderOption(
          props?.valueItem?.value,
          dataSourceFilterOptionsAll,
          formatMessage,
        )}
      </span>
    </>
  );
};

const RenderPlatform = (props: any) => {
  const { formatMessage } = useIntl();
  const { googlePlatformFilterOptions } = useFilterOptionList({
    formatMessage,
  });

  return (
    <>
      <span className="model-form-text">
        {formatMessage({ id: 'dbi_platform' })}
      </span>
      <span className="model-form-context">
        {renderOption(
          props?.valueItem?.value,
          googlePlatformFilterOptions,
          formatMessage,
        )}
      </span>
    </>
  );
};

const RenderAllCompany = (props: any): React.ReactElement => {
  const { valueItem, title } = props || {};
  const { formatMessage } = useIntl();
  const { value } = valueItem || {};
  const render = useMemo(() => {
    if (value?.length === 0) {
      return formatMessage({ id: 'dbi_all' });
    }
    if (value?.length > 2) {
      return value.length;
    }
    if (Array.isArray(value)) {
      return value.toString();
    }
  }, [value]);
  return (
    <>
      <span className="model-form-text">
        {formatMessage({ id: title || 'dbi_company' })}
      </span>
      <span className="model-form-context">{render}</span>
    </>
  );
};

const RenderAllGames = (props: any): React.ReactElement => {
  const { valueItem, selectGameBtnText } = props || {};
  const { formatMessage } = useIntl();
  const { value, checkedList = [] } = valueItem || {};
  const render = useMemo(() => {
    if (value?.length === 0) {
      return formatMessage({ id: 'dbi_all' });
    }
    if (value?.length > 1) {
      return value.length;
    }
    if (Array.isArray(checkedList)) {
      return checkedList[0]?.name || '';
    }
  }, [value]);
  return (
    <>
      <span className="model-form-text">
        {formatMessage({
          id:
            typeof selectGameBtnText === 'string'
              ? selectGameBtnText
              : 'dbi_games',
        })}
      </span>
      <span className="model-form-context">{render}</span>
    </>
  );
};

const RenderPHeat = (props: any): React.ReactElement => {
  const { valueItem } = props || {};
  const { formatMessage } = useIntl();
  const { value } = valueItem || {};
  return (
    <>
      <span className="model-form-text">
        {formatMessage({ id: 'dbi_heat_range' })}
      </span>
      <span className="model-form-context">{value?.join('-')}</span>
    </>
  );
};

const RenderPlan = (props: any): React.ReactElement => {
  const { valueItem } = props;
  const { formatMessage } = useIntl();
  const { planOptionFilterOptions } = useFilterOptionList({ formatMessage });

  return (
    <>
      <span className="model-form-text">
        {formatMessage({ id: 'dbi_top_plan' })}
      </span>
      <span className="model-form-context">
        {findTextByValue(planOptionFilterOptions, valueItem?.value)}
      </span>
    </>
  );
};

const RenderDigitalSegment = (props: any): React.ReactElement => {
  const { valueItem } = props;
  const { formatMessage } = useIntl();
  const segmentTooltip = (text: string) => text;
  const { digitalSegmentFilterOptions } = useFilterOptionList({
    formatMessage,
    segmentTooltip,
  });

  return (
    <>
      <span className="model-form-text">
        {formatMessage({ id: 'dbi_filter_segment' })}
      </span>
      <span className="model-form-context">
        {findTextByValue(digitalSegmentFilterOptions, valueItem?.value)}
      </span>
    </>
  );
};

const RenderConsoleDevice = (props: any): React.ReactElement => {
  const { valueItem, options, btnName } = props;
  const { formatMessage } = useIntl();
  const { value } = valueItem || {};
  return (
    <>
      <span className="model-form-text">
        {formatMessage({ id: btnName || 'dbi_device' })}
      </span>
      <span className="model-form-context">
        {renderOption(value, options, formatMessage)}
      </span>
    </>
  );
};

const RenderCascaderSegment = (props: any): React.ReactElement => {
  const { valueItem, key, ref, options } = props;
  // console.log('RenderCascaderRenderCascader', props);
  const { formatMessage } = useIntl();
  const segmentTooltip = (text: string) => text;
  const { cascaderSegmentFilterOptions } = useFilterOptionList({
    formatMessage,
    segmentTooltip,
  });
  const { value } = valueItem || {};
  if (key === 'platform_cascader') {
    const getRenderData = ref.current?.getInputData();
    const renderFuc = options.customInputDisplayRender;

    return (
      <>
        {/* <span className="model-form-text">
          {formatMessage({ id: 'dbi_platform' })}
        </span> */}
        <span className="model-form-context">{renderFuc(getRenderData)}</span>
      </>
    );
  }
  const valueFormatter = getValueFormatter(value);
  return (
    <>
      <span className="model-form-text">
        {formatMessage({ id: 'dbi_filter_segment' })}
      </span>
      <span className="model-form-context">
        {renderOption(
          valueFormatter,
          cascaderSegmentFilterOptions,
          formatMessage,
          true,
        )}
      </span>
    </>
  );
};

const RenderPublisher = (props: any): React.ReactElement => {
  const { valueItem } = props;
  const { formatMessage } = useIntl();
  const MAP = {
    NETWORK: 'dbi_metric_publisher_shared_value',
    all: 'dbi_metric_publisher_All_value',
    RETAIL: 'dbi_metric_publisher_retail_value',
  };
  // const segmentTooltip = (text: string) => text;
  // const { cascaderSegmentFilterOptions } = useFilterOptionList({
  //   formatMessage,
  //   segmentTooltip,
  // });
  // const { value } = valueItem || {};
  // const valueFormatter = getValueFormatter(value);
  return (
    <>
      <span className="model-form-text">
        {formatMessage({ id: 'dbi_metric_publisher' })}
      </span>
      <span className="model-form-context">
        {formatMessage({ id: MAP[valueItem?.value] || 'all' })}
      </span>
    </>
  );
};

const RenderSteamTags = (props: any): React.ReactElement => {
  const { formatMessage } = useIntl();
  const { valueItem, options, btnName, title, selectorConfig } = props;
  const { value } = valueItem || {};
  const render = useMemo(() => {
    if (value?.length === 0 || value?.length === options?.length) {
      return formatMessage({ id: 'dbi_all' });
    }
    if (value?.length > 1) {
      return value.length;
    }
    if (Array.isArray(value)) {
      const currentValue = value?.[0];
      const currentValueInfo = options.find(
        (item: { value: string }) => item?.value === currentValue,
      );
      return currentValueInfo?.text;
    }
  }, [value, options]);
  return (
    <>
      <span className="model-form-text">
        {formatMessage({
          id: title || selectorConfig?.label || btnName || 'dbi_top_steam_tags',
        })}
      </span>
      <span className="model-form-context">{render}</span>
    </>
  );
};

const RenderGameMode = (props: any): React.ReactElement => {
  const { formatMessage } = useIntl();
  const { valueItem, options, btnName } = props;
  const { value } = valueItem || {};
  const render = useMemo(() => {
    if (value?.length === 0 || value?.length === options?.length) {
      return formatMessage({ id: 'dbi_all' });
    }
    if (value?.length > 1) {
      return value.length;
    }
    if (Array.isArray(value)) {
      const currentValue = value?.[0];
      const currentValueInfo = options.find(
        (item: { value: string }) => item?.value === currentValue,
      );
      return currentValueInfo?.text;
    }
  }, [value, options]);
  return (
    <>
      <span className="model-form-text">
        {formatMessage({ id: btnName || 'dbi_top_game_mode' })}
      </span>
      <span className="model-form-context">{render}</span>
    </>
  );
};

const RenderGameEngine = (props: any): React.ReactElement => {
  const { formatMessage } = useIntl();
  const { valueItem, options, selectorConfig } = props;
  const { value } = valueItem || {};
  const render = useMemo(() => {
    if (value?.length === 0 || value?.length === options?.length) {
      return formatMessage({ id: 'dbi_all' });
    }
    if (value?.length > 1) {
      return value.length;
    }
    if (Array.isArray(value)) {
      const currentValue = value?.[0];
      const currentValueInfo = options.find(
        (item: { value: string; text?: string }) => item?.value === currentValue,
      );
      return currentValueInfo?.text || currentValue;
    }
  }, [value, options]);

  return (
    <>
      <span className="model-form-text">
        <img
          className="model-form-text__icon"
          src={getDataSourceIcon('igdb')}
          alt=""
        />
        {formatMessage({ id: selectorConfig?.label || 'dbi_top_game_engine' })}
      </span>
      <span className="model-form-context">{render}</span>
    </>
  );
};

const RenderHotTagsSource = (props: any): React.ReactElement => {
  const { valueItem, options } = props;
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const selectedValue = valueItem?.value;
  const selectedName =
    typeof selectedValue === 'string' ? selectedValue : selectedValue?.name;
  const currentOption = useMemo(() => {
    if (!selectedName) {
      return undefined;
    }

    return options?.find((item: any) => item?.name === selectedName);
  }, [options, selectedName]);

  const render = useMemo(() => {
    if (!selectedName) {
      return formatMessage({ id: 'dbi_filterSave_none' });
    }

    if (locale === LOCALE_CN) {
      return currentOption?.name_cn || currentOption?.name || selectedName;
    }

    return currentOption?.name_en || currentOption?.name || selectedName;
  }, [currentOption, formatMessage, locale, selectedName]);

  return (
    <>
      <span className="model-form-text">
        <span className="model-form-icon">
          <SvgIcon className="dbi-hot-tags-source-icon" type="new-logo" />
        </span>
        {formatMessage({ id: 'dbi_hot_tags' })}
      </span>
      <span className="model-form-context">{render}</span>
    </>
  );
};

const RenderDigitalSegmentMULTIPLE = (props: any): React.ReactElement => {
  const { valueItem } = props;
  // console.log('RenderDigitalSegmentMULTIPLE', props);
  const { formatMessage } = useIntl();
  const segmentTooltip = (text: string) => text;
  const { digitalSegmentFilterOptions } = useFilterOptionList({
    formatMessage,
    segmentTooltip,
  });
  const { value } = valueItem || {};
  return (
    <>
      <span className="model-form-text">
        {formatMessage({ id: 'dbi_filter_segment' })}
      </span>
      <span className="model-form-context">
        {renderOption(value, digitalSegmentFilterOptions, formatMessage)}
      </span>
    </>
  );
};

const RenderSinglePlatformSelect = (props: any): React.ReactElement => {
  const { valueItem, entityType, platforms } = props;
  const { formatMessage } = useIntl();
  const { value } = valueItem || {};
  const options = renderSinglePlatformOptions(entityType, platforms);
  return (
    <>
      <span className="model-form-text">
        {formatMessage({ id: 'dbi_platform' })}
      </span>
      <span className="model-form-context">
        {renderOption(value, options, formatMessage)}
      </span>
    </>
  );
};

const RenderSingleSourceSelect = (props: any): React.ReactElement => {
  const { valueItem, entityType, sources } = props;
  const { formatMessage } = useIntl();
  const { value } = valueItem || {};
  const options = getStoreRankPlatformOptions(
    entityType,
    sources,
    formatMessage,
  );
  return (
    <>
      <span className="model-form-text">
        {formatMessage({ id: 'dbi_ranking' })}
      </span>
      <span className="model-form-context">
        {renderOption(value, options, formatMessage)}
      </span>
    </>
  );
};
const RenderComposedCountrySelect = (props: any): React.ReactElement => {
  const { valueItem, options: regionOptions, title } = props;
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const { value } = valueItem || {};
  const countriesValues = value?.countries || [];
  const allChildren: any[] = getRegionSubOptions(regionOptions);

  if (countriesValues?.length === 1) {
    const oneMarket = countriesValues[0];
    const findMarket = allChildren?.find((item) => item?.value === oneMarket);
    return (
      <>
        <span className="model-form-text">
          {formatMessage({ id: title || 'dbi_country' })}
        </span>
        <span className="model-form-context">
          {getText(findMarket, locale) || oneMarket}
        </span>
      </>
    );
  }
  return (
    <>
      <span className="model-form-text">
        {formatMessage({ id: title || 'dbi_country' })}
      </span>
      <span className="model-form-context">
        {countriesValues?.length === allChildren?.length
          ? formatMessage({ id: 'dbi_all' })
          : countriesValues?.length}
      </span>
    </>
  );
};

const RenderGameTypeSelector = (props: any): React.ReactElement => {
  const { valueItem } = props;
  const { value } = valueItem || {};
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const gameTypeTitle = useMemo(() => {
    if (!Array.isArray(value)) return '';
    if (value.length === 3) return formatMessage({ id: 'dbi_all' });
    if (value.length === 1) return formatMessage({ id: `dbi_${value[0]}` });
    return value.length;
  }, [value, locale]);
  return (
    <>
      <span className="model-form-text">
        {formatMessage({ id: 'dbi_company_game_type' })}
      </span>
      <span className="model-form-context">{gameTypeTitle}</span>
    </>
  );
};

const RenderIPOStatusSelector = (props: any): React.ReactElement => {
  const { valueItem } = props;
  const { value } = valueItem || {};
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const ipoStatusesNamesMapping = getIPOStatusesNamesMapping();
  const ipoStatusTitle = useMemo(() => {
    if (!Array.isArray(value)) return '';
    if (value.length === 3) return formatMessage({ id: 'dbi_all' });
    if (value.length === 1) return ipoStatusesNamesMapping[value[0]];
    return value.length;
  }, [value, locale]);
  return (
    <>
      <span className="model-form-text">
        {formatMessage({ id: 'dbi_company_ipo_status' })}
      </span>
      <span className="model-form-context">{ipoStatusTitle}</span>
    </>
  );
};

const RenderCountrySelector = (props: any): React.ReactElement => {
  const { valueItem, title, options } = props;
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const { value } = valueItem || {};
  const countryTitle = useMemo(() => {
    if (!Array.isArray(value)) return '';
    if (value.length === options?.length)
      return formatMessage({ id: 'dbi_all' });
    if (value.length === 1) {
      const targetCountry = options?.find(
        (item: any) => item?.value === value[0],
      );
      if (targetCountry) {
        return locale === 'zh-CN'
          ? targetCountry?.textCN
          : targetCountry?.textEN;
      }
      return value[0];
    }
    return value.length;
  }, [value, locale]);
  return (
    <>
      <span className="model-form-text">{formatMessage({ id: title })}</span>
      <span className="model-form-context">{countryTitle}</span>
    </>
  );
};

const RenderRevenueRangeSelect = (props: any): React.ReactElement => {
  // console.log(props)
  const { valueItem = {}, title, titleDefaultMessage } = props;
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const { value = {} } = valueItem;
  const { min, max } = value;
  const revenueRangeTitle = useMemo(() => {
    if (value && max) {
      return `${newMathFormat(min, true)} ~ ${newMathFormat(max, true)}`;
    }

    if (min && !max) {
      return `${newMathFormat(min, true)} ~ `;
    }

    if (!min && max) {
      return `~ ${newMathFormat(max, true)}`;
    }

    return formatMessage({ id: 'dbi_filterSave_none' });
  }, [min, max, locale]);

  return (
    <>
      <span className="model-form-text">
        {formatMessage({
          id: title || 'dbi_revenue_range',
          defaultMessage: titleDefaultMessage,
        })}
      </span>
      <span className="model-form-context">{revenueRangeTitle}</span>
    </>
  );
};

const RenderRevenueGrowthSelect = (props: any): React.ReactElement => {
  const { labelLocaleKey = 'dbi_revenue_growth', valueItem } = props;
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const { value } = valueItem || {};
  const growthTitle = useMemo(() => {
    if (value?.opt && value?.value) {
      return `${filterKeyMap.OPT_MAP?.[value?.opt] || value?.opt} ${
        value?.value
      }%`;
    }

    return formatMessage({ id: 'dbi_filterSave_none' });
  }, [locale]);
  return (
    <>
      <span className="model-form-text">
        {formatMessage({ id: labelLocaleKey })}
      </span>
      <span className="model-form-context">{growthTitle}</span>
    </>
  );
};

const RenderRevenueScopeSelect = (props: any): React.ReactElement => {
  const { title = 'dbi_revenue', valueItem } = props;
  const { formatMessage } = useIntl();
  const { value } = valueItem || {};

  const revenueScopeTitle = (() => {
    if (value === REVENUE_SCOPE_VALUES.INCLUDING) {
      return formatMessage({ id: 'dbi_revenue_scope_including_store_fees' });
    }

    if (value === REVENUE_SCOPE_VALUES.EXCLUDING) {
      return formatMessage({ id: 'dbi_revenue_scope_excluding_store_fees' });
    }

    return formatMessage({ id: 'dbi_filterSave_none' });
  })();

  return (
    <>
      <span className="model-form-text">{formatMessage({ id: title })}</span>
      <span className="model-form-context">{revenueScopeTitle}</span>
    </>
  );
};

const RenderRevenueRangeUnitSelect = (props: any): React.ReactElement => {
  const { valueItem = {}, title } = props;
  const { value = {} } = valueItem;

  const { formatMessage } = useIntl();
  const locale = getLocale();
  const revenueRangeTitle = useMemo(() => {
    if (!value) return formatMessage({ id: 'dbi_filterSave_none' });
    const { min = {}, max = {} } = value;
    const minValue = min?.value || '';
    const maxValue = max?.value || '';
    const minUnit = min?.unit || '';
    const maxUnit = max?.unit || '';
    if (minValue && maxValue) {
      return `${minValue}${minValue !== '0' ? minUnit : ''} ~ ${maxValue}${
        maxUnit !== '0' ? maxUnit : ''
      }`;
    }

    if (minValue && !maxValue) {
      return `${minValue}${minValue !== '0' ? minUnit : ''} ~`;
    }

    if (!minValue && maxValue) {
      return `~ ${maxValue}${maxUnit !== '0' ? maxUnit : ''}`;
    }

    return formatMessage({ id: 'dbi_filterSave_none' });
  }, [value, locale]);

  return (
    <>
      <span className="model-form-text">
        {formatMessage({ id: title || 'dbi_revenue_range_unit' })}
      </span>
      <span className="model-form-context">{revenueRangeTitle || ''}</span>
    </>
  );
};

// 渲染函数
// const nameFun = (props: any): React.ReactElement => {
//  const { key, valueItem } = props;
//   return (
//     <>
//       <span className="model-form-text">name</span>
//       <span className="model-form-context">value</span>
//     </>
//   );
// };

const RenderSensorTowerTagSelect = (props: any) => {
  const { valueItem, key, title, options } = props;
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const { value } = valueItem || {};
  const sensorTowerTagTitle = useMemo(() => {
    if (!value?.length) return formatMessage({ id: 'dbi_filterSave_none' });

    if (value?.length === 1) {
      if (key === SENSOR_TOWER_TAG_THEME) {
        const theme = analysisDataSourceMetricKey(value[0], COMMON_JOINER);
        const themeTag = options?.find(
          (item: any) => item?.value === theme?.dataSource,
        );
        if (themeTag) {
          const tag = themeTag?.children || [];
          const target = tag?.find((item: any) => item?.value === value[0]);
          if (target) {
            return locale === LOCALE_CN ? target?.textCN : target?.text;
          }
        }
        return theme?.metric || '';
      }
      const target = options?.find((item: any) => item?.value === value[0]);
      if (target) {
        return locale === LOCALE_CN ? target?.textCN : target?.text;
      }
    }

    if (value?.length === options?.length) {
      return formatMessage({ id: 'dbi_all' });
    }
    return value?.length;
  }, [value, locale]);
  return (
    <>
      <span className="model-form-text">
        {formatMessage({ id: title || 'dbi_detail_art_style' })}
      </span>
      <span className="model-form-context">{sensorTowerTagTitle}</span>
    </>
  );
};

const RenderAppmagicTagSelect = (props: any) => {
  const { title, options, valueItem } = props;

  const { formatMessage } = useIntl();
  const locale = getLocale();

  const { value } = valueItem || {};

  const appmagicTagTitle = useMemo(() => {
    if (!Array.isArray(value) || value.length === 0) {
      return formatMessage({ id: 'dbi_filterSave_none' });
    }

    const valueLength = value.length;

    if (valueLength === options?.length) {
      return formatMessage({ id: 'dbi_all' });
    }

    if (valueLength === 1) {
      const firstValue = value[0];
      const target = options?.find((item: any) => item?.value === firstValue);
      if (target) {
        const targetText = target?.text || '';
        return getOptionText(locale, {
          value: firstValue,
          text: targetText,
          textEN: targetText,
          textCN: target?.textCN,
        });
      }

      return firstValue;
    }

    return valueLength;
  }, [locale, value]);

  return (
    <>
      <span className="model-form-text">
        <img className="model-form-text__icon" src={ICON_APPMAGIC} alt="" />
        {formatMessage({ id: title || 'dbi_detail_art_style' })}
      </span>
      <span className="model-form-context">{appmagicTagTitle}</span>
    </>
  );
};

const RenderMetricSelectForKPITrends = (props: any) => {
  // console.log('RenderMetricSelectForKPITrends', props);
  const { valueItem } = props;
  const { formatMessage } = useIntl();
  const { value } = valueItem || {};
  const { metricsOptions: selectMetricsOptions } = value;

  const showTotal = false;
  const hasAll = false;
  const showIcon = true;

  const metricRender = selectMetricsOptions?.map((e: any) => {
    return {
      ...e,
      value: e?.value,
      textStr_tmp: formatMessage({ id: e?.text || e?.value }),
      key: e?.text || e?.value,
      text: showIcon ? (
        <IconDom
          data={{
            text: formatMessage({ id: e?.text || e?.value }),
            img: getDataSourceIcon(
              e?.icon ? e?.icon : e?.dataSource || e?.value,
            ),
          }}
        />
      ) : (
        formatMessage({ id: e?.text || e?.value })
      ),
    };
  });
  if (hasAll) {
    metricRender?.unshift({
      text: (
        <>
          {showTotal
            ? `${formatMessage({ id: 'dbi_all' })}(${
                selectMetricsOptions?.length
              })`
            : formatMessage({ id: 'dbi_all' })}
        </>
      ),
      textStr_tmp: 'All',
      value: 'all',
    });
  }

  return (
    <div className="dbi-metric-select">
      <div className="dbi-metric-select-lable">
        {formatMessage(
          { id: 'dbi_top_metric_intotal' },
          { number: metricRender?.length },
        )}
      </div>
      <div className="dbi-metric-select-text">
        <div className="dbi-metric-select-value">
          {metricRender?.map((e: any, index: number) => {
            return (
              <>
                <span
                  className="dbi-metric-select-span"
                  key={e.text + e?.value}
                >
                  {e.text}
                  {index !== metricRender?.length - 1 && <>,&nbsp;</>}
                </span>
              </>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default {
  // [filterKeyMap.MY_FILTER]: renderMyFilter,
  [filterKeyMap.RANGE_TIME]: RenderRangeDate,
  // [filterKeyMap.TIME_TYPE]: renderTimeType,
  [filterKeyMap.REGION]: RenderRegion,
  [filterKeyMap.GENRETOR]: RenderGenretor,
  [filterKeyMap.GENRETOR_WITH_SEGMENT]: RenderGenretor,
  [filterKeyMap.DATASOURCE]: RenderDataSource,
  [filterKeyMap.DATASOURCESIM]: RenderDataSourceSingle,
  [filterKeyMap.PLATFORM]: RenderPlatform,
  [filterKeyMap.PHEAD_RANG]: RenderPHeat,
  [filterKeyMap.ALL_COMPANYS]: RenderAllCompany,
  [filterKeyMap.ALL_Games]: RenderAllGames,
  // [filterKeyMap.STREAMING_PLATFORM]: renderStreamingPlatform,
  [filterKeyMap.PLAN]: RenderPlan,
  // [filterKeyMap.RETENTION]: renderRetention,
  [filterKeyMap.GAME_TYPE]: RenderGameTypeSelector,
  [filterKeyMap.IPO_STATUS]: RenderIPOStatusSelector,
  [filterKeyMap.COUNTRY]: RenderCountrySelector,
  [filterKeyMap.CONSOLE_DEVICE]: RenderConsoleDevice,
  [filterKeyMap.DIGITAL_SEGEMENT]: RenderDigitalSegment,
  [filterKeyMap.DIGITAL_SEGMENT_MULTIPLE]: RenderDigitalSegmentMULTIPLE,
  // [filterKeyMap.COMPOSED_SELECT]: renderComposedSelect,
  [filterKeyMap.COMPOSED_COUNTRY_SELECT]: RenderComposedCountrySelect,
  [filterKeyMap.REGION_CASCADER_SELECT]: RenderComposedCountrySelect,
  [filterKeyMap.SINGLE_PLATFORM_SELECT]: RenderSinglePlatformSelect,
  [filterKeyMap.SINGLE_SOURCE_SELECT]: RenderSingleSourceSelect,
  [filterKeyMap.REVENUE_RANGE]: RenderRevenueRangeSelect,
  [filterKeyMap.ARPU_RANGE]: RenderRevenueRangeSelect,
  [filterKeyMap.ACTIVE_USERS_RANGE]: RenderRevenueRangeSelect,
  [filterKeyMap.DOWNLOADS_RANGE]: RenderRevenueRangeSelect,
  [filterKeyMap.RPD_RANGE]: RenderRevenueRangeSelect,
  ...filterKeyMap.assignFilterKeys(filterKeyMap.RETENTION_D_RANGE_KEYS, RenderRevenueRangeSelect),
  [filterKeyMap.REVENUE_SCOPE]: RenderRevenueScopeSelect,
  [filterKeyMap.REVENUE_RANGE_UNIT]: RenderRevenueRangeUnitSelect,
  [filterKeyMap.REVENUE_GROWTH]: RenderRevenueGrowthSelect,
  [filterKeyMap.PCU_RANGE]: RenderRevenueRangeSelect,
  [filterKeyMap.DIGITAL_RANGE]: RenderRevenueRangeSelect,
  [filterKeyMap.PHYSICAL_RANGE]: RenderRevenueRangeSelect,
  [filterKeyMap.PRICE_RANGE]: RenderRevenueRangeSelect,
  [filterKeyMap.PREMIUM_RANGE]: RenderRevenueRangeSelect,
  [filterKeyMap.SENSOR_TOWER_TAG_ART_STYLE]: RenderSensorTowerTagSelect,
  [filterKeyMap.SENSOR_TOWER_TAG_CAMERA_POV]: RenderSensorTowerTagSelect,
  [filterKeyMap.SENSOR_TOWER_TAG_PRODUCT_MODEL]: RenderSensorTowerTagSelect,
  [filterKeyMap.SENSOR_TOWER_TAG_SETTING]: RenderSensorTowerTagSelect,
  [filterKeyMap.SENSOR_TOWER_TAG_TAGS]: RenderSensorTowerTagSelect,
  [filterKeyMap.SENSOR_TOWER_TAG_THEME]: RenderSensorTowerTagSelect,
  [filterKeyMap.SENSOR_TOWER_TAG_MONETIZATION]: RenderSensorTowerTagSelect,
  [filterKeyMap.APPMAGIC_TAG_THEMES]: RenderAppmagicTagSelect,
  [filterKeyMap.APPMAGIC_TAG_FEATURES]: RenderAppmagicTagSelect,
  [filterKeyMap.APPMAGIC_TAG_IP]: RenderAppmagicTagSelect,
  [filterKeyMap.APPMAGIC_TAG_SETTINGS]: RenderAppmagicTagSelect,
  [filterKeyMap.APPMAGIC_TAG_ART_STYLES]: RenderAppmagicTagSelect,
  [filterKeyMap.METRIC_SELECT_FOR_KPI_TREND]: RenderMetricSelectForKPITrends,
  [filterKeyMap.STEAM_TAGS]: RenderSteamTags,
  [filterKeyMap.GAME_MODE]: RenderGameMode,
  [filterKeyMap.GAME_ENGINE]: RenderGameEngine,
  [filterKeyMap.HOT_TAGS_SOURCE]: RenderHotTagsSource,
  [filterKeyMap.CASCADER]: RenderCascaderSegment,
  [filterKeyMap.PUBLISHER]: RenderPublisher,
  [filterKeyMap.MOBILE_OVERLAP]: (props: any) => {
    return RenderRevenueGrowthSelect({ ...props, labelLocaleKey: 'dbi_metric_mobile_cross_usage' });
  },
};
